<template>
    <card v-if="!session.sync && hasIssues">

        <h3 class="mb-0" slot="header">{{ $t('common.issues') }}</h3>
        
        <p class="mb-4">
            {{ $t('issues.send-issues-notice') }}
        </p>

        <base-button type="primary" :loading="sending" @click.prevent="sendIssues">
            <i class="fas fa-paper-plane mr-1"></i> {{ $t('issues.send-now') }}
        </base-button>

        <portal to="modals">

            <confirm-modal v-model="modals.confirmSend">
                <p>{{ $t('issues.send-now-confirm') }}</p>
            </confirm-modal>

        </portal>
    </card>
</template>

<script>
    import ModalsController from '@trax/classes/ModalsController'
    import SyncModal from '../../offline/SyncModal'

    export default {

        components: {
            SyncModal
        },

        props: {
            session: {
                type: Object,
                required: true
            },

            stats: {
                type: Object,
                required: true
            },
        },

        data() {
            return {
                sending: false,

                // Offline.
                modals: new ModalsController(['confirmSend']),
            }
        },

        created() {
            this.modals.init(this, 'modals')
        },

        computed: {

            hasIssues() {
                return this.stats.issues
            }
        },

        methods: {
            
            sendIssues() {
                this.modals.open('confirmSend').then(resp => {
                    if (resp.confirmed) {
                        this.sending = true

                        // Pilot. Just a notification.
                        axios.post('/socrates/api/front/dashboard/data/sessions/'+this.session.id+'/summary/issues')
                        .then(resp => {
                            this.sending = false
                            this.$notify({type: 'primary', message: this.$t('feedbacks.sent') })
                        }).catch(error => {
                            this.sending = false
                            if (error.response.status == 404) {
                                this.$notify({type: 'danger', message: this.$t('feedbacks.send-failed') })
                            } else if (error.response.status == 500 && error.response.data.message) {
                                this.$notify({type: 'danger', message: error.response.data.message })
                            } else {
                                this.$auth.handleErrorVm(error, this)
                            }
                        });
                    }
                })
            },
        }
    }
</script>

